import React from 'react';
import { Box, Paper, Typography, useTheme, alpha } from '@mui/material';
import Grid from '@mui/material/Grid2';

const SummaryCard = ({ title, value, subtitle, icon: Icon, color = 'primary', bgColor }) => {
    const theme = useTheme();

    // Resolve color from theme palette if it's a palette color name
    const getColorValue = (colorProp) => {
        if (theme.palette[colorProp]?.main) {
            return theme.palette[colorProp].main;
        }
        return colorProp; // Return as-is if it's already a color value
    };

    const finalColor = getColorValue(color);
    const finalBgColor = bgColor || alpha(finalColor, 0.1);

    return (
        <Paper
            elevation={0}
            sx={{
                p: 2.5,
                height: '100%',
                border: '1px solid',
                borderColor: 'divider',
                borderRadius: 3,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                transition: 'transform 0.2s ease-in-out, box-shadow 0.2s ease-in-out',
                '&:hover': {
                    transform: 'translateY(-2px)',
                    boxShadow: '0 4px 20px rgba(0,0,0,0.05)',
                    borderColor: 'transparent',
                },
            }}
        >
            <Box>
                <Typography
                    variant="body2"
                    color="text.secondary"
                    fontWeight={500}
                    sx={{
                        mb: 0.5,
                        textTransform: 'uppercase',
                        letterSpacing: '0.5px',
                        fontSize: '0.75rem',
                    }}
                >
                    {title}
                </Typography>
                <Typography variant="h4" fontWeight={700} color="text.primary">
                    {value}
                </Typography>
                {subtitle && (
                    <Typography
                        variant="caption"
                        color="text.secondary"
                        sx={{ mt: 0.5, display: 'block' }}
                    >
                        {subtitle}
                    </Typography>
                )}
            </Box>
            {Icon && (
                <Box
                    sx={{
                        width: 48,
                        height: 48,
                        borderRadius: '12px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        bgcolor: finalBgColor,
                        color: finalColor,
                    }}
                >
                    <Icon sx={{ fontSize: 24 }} />
                </Box>
            )}
        </Paper>
    );
};

const SummaryCards = ({ cards = [] }) => {
    if (!cards || cards.length === 0) {
        return null;
    }

    return (
        <Grid container spacing={2} sx={{ mb: 3 }}>
            {cards.map((card, index) => (
                <Grid size={{ xs: 12, sm: 6, md: cards.length > 4 ? 2.4 : 3 }} key={index}>
                    <SummaryCard {...card} />
                </Grid>
            ))}
        </Grid>
    );
};

export default SummaryCards;
